import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { format } from "date-fns";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import "rsuite/dist/rsuite.min.css";
import { API_URL, BASE_URL } from "../Config";
import config from "../common/Config";

const AllPushInvoice = () => {
  const [salesDates, setSalesDates] = useState([null, null]);
  const salesOrderRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");

  // Handle form submit, set date range and trigger getSalesOrderList immediately
  const handleSubmit = (e) => {
    e.preventDefault();
    const [startDate, endDate] = salesDates;
    let formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
    let formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
    getSalesOrderList(formattedStartDate, formattedEndDate);
  };

  // Fetch sales order list from API
  const getSalesOrderList = (startDate, endDate) => {
    const $table = $(salesOrderRef.current);
    // Destroy any existing DataTable instance to reinitialize with new data
    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().destroy();
    }
    $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/pushall/invoices`,
        type: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return $.extend({}, d, {
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchByFromdate: startDate,
            searchByTodate: endDate,
            authorization: `Bearer ${accessToken}`,
          });
        },
        dataSrc: function (json) {
          return Array.isArray(json.data) ? json.data : [];
        },
      },
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      columns: [
        {
          data: null,
          title: "Sr. No.",
          orderable: false,
          render: function (data, type, row, meta) {
            return meta.row + 1 + (meta.settings._iDisplayStart || 0);
          },
        },
        { data: "invoice_date", className: "text-start", width: "10%" },
        {
          data: null,
          className: "text-start",
          width: "12%",
          render: function (data, type, row) {
            return (
              '<a href="' +
              BASE_URL +
              "/trip_summary/print/" +
              row.id +
              '">' +
              row.invoice_number +
              "</a>"
            );
          },
        },
        { data: "customer" },
        { data: "invoice_amount", className: "text-end", width: "10%" },
      ],
      order: [],
      pageLength: 50,
    });
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    getSalesOrderList("", "");
    return () => {
      if (
        salesOrderRef.current &&
        $.fn.DataTable.isDataTable(salesOrderRef.current)
      ) {
        $(salesOrderRef.current).DataTable().destroy();
      }
    };
  }, []);

  return (
    <>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href={config.BASE_URL + "/Dashboard"}>
                <i className="fa fa-home"></i>
              </a>
              &nbsp;&gt;&nbsp;
              <a href={config.BASE_URL + "/account/payments"}>Account</a>
              &nbsp;&gt;&nbsp;
              <span className="last-crumb">All Push Invoiced</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div>
                <div className="row">
                  <div className="col-md-12 col-lg-6 col-sm-12">
                    <CustomDateRangePicker
                      dates={salesDates}
                      onChange={setSalesDates}
                      onSubmit={handleSubmit}
                    />
                  </div>
                </div>
                <div className="total-manifests-area dashboard">
                  <div className="col-md-12 col-lg-12 col-xs-12">
                    <div
                      className="verical-scrl-wrapper allpush-invoice-area"
                      id="style-3"
                    >
                      <table
                        className="table table-bordered dataTable resizable"
                        ref={salesOrderRef}
                      >
                        <thead>
                          <tr>
                            <th>Sr. No.</th>
                            <th>Invoiced Date</th>
                            <th>Invoice Number</th>
                            <th>Customer Name(Ac/No)</th>
                            <th>Invoice Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* DataTable will populate this dynamically */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AllPushInvoice;
